import { throttle } from 'lodash-es'
import { useCallback, useMemo } from 'react'

import { noOp } from '@/utils/helpers'
import type { UserPresencePayload } from '@/server/services/userPresence/types'

import { useUser } from '@/client/context/user'
import RPC from '@/client/rpc'
import { isUserDefined, isUserSuspended } from '@/client/services/user'

/**
 * This hook DOES NOT handle dynamic payload. It requires a static value to work.
 */
export default function useUserPresenceHeartbeat(
  payload: UserPresencePayload,
  intervalMs: number
): () => void {
  const user = useUser()

  const heartbeat = useCallback(() => {
    if (isUserDefined(user) && !isUserSuspended(user)) {
      RPC.userPresence(payload, { disableProgressBar: true, disableTracking: true }).catch(noOp)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user])

  const callback = useMemo(
    () => throttle(heartbeat, intervalMs, { leading: true, trailing: true }),
    [heartbeat, intervalMs]
  )

  return callback
}
